/** @format */

import React from 'react';
import { useStyles } from './style';
import 'react-tabs/style/react-tabs.css';
import { Typography, Grid } from '@mui/material';
import clsx from 'clsx';

const InfoBox = ({ title, content, children, type = 'error', ...rest }) => {
  // error, disable or error
  const classes = useStyles();

  return (
    <Grid containe className={clsx(classes.root, classes[type])}>
      {title ? (
        <Grid item xs={12}>
          <Typography className={clsx(classes.title, classes[`${type}Title`])} variant="h5">
            {title}
          </Typography>
        </Grid>
      ) : null}
      {content ? (
        <Grid item xs={12}>
          <Typography variant="body" style={{ marginTop: title ? 10 : 0 }}>
            {content}
          </Typography>
        </Grid>
      ) : null}
      {children}
    </Grid>
  );
};



export default InfoBox;
